import { ResponseModal2Component } from './../../components/response-modal2/response-modal2.component';
import { Component, OnInit, ViewChild, Input, Injectable, Inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountStatusService } from './../../services/account-status/account-status.service';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../services/storage.service';
import { User } from '../../models/user';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { NgbDateStruct, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { SearchInvoicesService } from '../../services/search-invoices.service';
import { SendFilesComponent } from './send-files/send-files.component';
import { DownloadFilesComponent } from './download-files/download-files.component';
import { FormControl, Validators } from '@angular/forms';

interface AngSelectEvent {
  nombre: string;
  userId: any;
}

const I18N_VALUES = {
  'es': {
    weekdays: ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'],
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  }
};

@Injectable()
export class I18n {
  lang; language;
  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    // console.log(this.storage.get('LOCAL_STORAGE'));
    this.lang = this.storage.get('LOCAL_STORAGE');

    if (this.lang === 'es') {
      this.language = this.lang;
    } else {
      this.language = 'en';
    }
  }
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-accountstatus',
  templateUrl: './account-status.component.html',
  providers: [AccountStatusService,
    I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }]
})
export class AccountStatusComponent implements OnInit {
  @ViewChild('mydatatable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  private basePath;
  public user: User;
  rows: any = [];
  selected = [];
  facturas;
  rol;
  usuario;
  usuarioID;
  rfc;
  sociedad;
  proveedores;
  clienteFilter;
  rfcSeleccionado;
  busyBusqueda: boolean = false;
  select: boolean = false;
  show: boolean = false;
  dp1 = new FormControl('', Validators.required);
  permiso;
  pSD: boolean = false;
  pFI: boolean = false;
  pAM: boolean = false;

  filtros = {
    tipoConsulta: '',
    tipoFactura: true,
    modulo: null,
    folio1: '',
    folio2: '',
    serie1: '',
    serie2: '',
    desde: "",
    hasta: "",
    cliente: '',
    rfc: ''
  }

  c = 'holas';
  mensajeCli: boolean = false;
  tipo;
  fechaD;
  date1: boolean = false;
  date2: boolean = false;
  module: boolean = false;
  tFact: boolean = false;
  clt: boolean = false;
  isInternal: boolean = false;
  clientes: Array<any> = [];

  maxDateInicio = new Date();
  maxDateFin: Object = {};

  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();
  //<string>
  fechasValidas: boolean = false;
  toastMessage;
  toastRangoFechasValido;
  toastEmptyInvoice;
  toastLimitInvoice;
  limitInvoiceM;

  events: AngSelectEvent[] = [];
  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
    

  constructor(
    private translate: TranslateService,
    private storageService: StorageService,
    private facturaRemService: SearchInvoicesService,
    private modalService: NgbModal,
    private accountStatus: AccountStatusService,
    private toasterService: ToasterService
  ) {
    this.translate.get('texto.NoHayFacturas').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

    this.translate.get('texto.seleccionadoLabel').subscribe(
      text => {
        this.messages.selectedMessage = text;
      });

    this.translate.get('texto.especificarRangoFechas').subscribe(
      text => {
        this.toastMessage = text;
      });

    this.translate.get('texto.rangoFechasValido').subscribe(
      text => {
        this.toastRangoFechasValido = text;
      });

    this.translate.get('texto.emptyInvoice').subscribe(
      text => {
        this.toastEmptyInvoice = text;
      });

    this.translate.get('texto.limitInvoice').subscribe(
      text => {
        this.toastLimitInvoice = text;
      });
      
    this.translate.get('texto.limitInvoiceM').subscribe(
      text => {
        this.limitInvoiceM = text;
      });

  }

  ngOnInit() {
    this.noBack();
    this.user = this.storageService.getCurrentUser();
    this.rol = this.user.rol;
    this.permiso = this.user.permiso;
    this.usuario = this.user.nombre;
    this.usuarioID = this.user.userId;
    this.rfc = this.user.rfc;
    this.sociedad = this.user.sociedad;
    if (this.user.rol !== 2) {
      this.isInternal = true;
    }
    this.verPermisos();
  }

  verPermisos() {

    if (this.permiso == 'SD') {
      this.pSD = true;
      this.pFI = false;
      this.pAM = false;
    } else if (this.permiso === 'FI') {
      this.pSD = false;
      this.pFI = true;
      this.pAM = false;
    } else if (this.permiso == 'AM') {
      this.pSD = true;
      this.pFI = true;
      this.pAM = true;
    } else {
      this.pSD = false;
      this.pFI = false;
      this.pAM = false;
    }
  }

  cliente(e, cli) {
    ;

    this.c = '';
    this.c = cli.filterValue;
    // console.log(e);
    // console.log(cli);
    if (this.c.length < 5) {
      this.mensajeCli = true;
    } else {
      this.mensajeCli = false;
    }


  }

  clienteSelected(e) {
    // console.log(e);
    this.rfcSeleccionado = e.rfc;
  }

  calcularFechaFin(e) {
    let date = e;
    let currentYear = new Date().getFullYear();
    (<HTMLInputElement>document.getElementById('fechaHasta')).value = "";
    if (this.rol == 2) {
      // console.log(this.rol);
      if (date.month == 10) {
        this.maxDateFin = { year: currentYear + 1, month: 1, day: date.day }
      } else if (date.month == 11) {
        this.maxDateFin = { year: currentYear + 1, month: 2, day: date.day }
      } else if (date == 12) {
        this.maxDateFin = { year: currentYear + 1, month: 3, day: date.day }
      } else {
        this.maxDateFin = { year: date.year, month: date.month + 3, day: date.day }
      }
    } else {
      if (date.month == 7) {
        this.maxDateFin = { year: currentYear + 1, month: 1, day: date.day }
      } else if (date.month == 8) {
        this.maxDateFin = { year: currentYear + 1, month: 2, day: date.day }
      } else if (date.month == 9) {
        this.maxDateFin = { year: currentYear + 1, month: 3, day: date.day }
      } else if (date.month == 10) {
        this.maxDateFin = { year: currentYear + 1, month: 4, day: date.day }
      } else if (date.month == 11) {
        this.maxDateFin = { year: currentYear + 1 , month: 5, day: date.day }
      } else if (date == 12) {
        this.maxDateFin = { year: currentYear + 1, month: 6, day: date.day }
      } else {
        this.maxDateFin = { year: date.year, month: date.month + 6, day: date.day }
      }
    }

  }



  buscar() {
    this.selected = [];
    this.module = true;
    this.busyBusqueda = true;
    this.filtros.desde = (<HTMLInputElement>document.getElementById('fechaDesde')).value;
    this.filtros.hasta = (<HTMLInputElement>document.getElementById('fechaHasta')).value;
    let ventas = (<HTMLInputElement>document.getElementById('inlineRadio1'));
    let finanzas = (<HTMLInputElement>document.getElementById('inlineRadio2'));
    let vent_finan = (<HTMLInputElement>document.getElementById('inlineRadio3'));
    if (this.user.rol === 3 || this.user.rol === 1) {
      this.filtros.rfc = this.rfcSeleccionado;
    } else {
      this.filtros.rfc = this.user.rfc;
    }
    // console.log(this.filtros);

    if (this.filtros.tipoConsulta !== '') {
      if (this.show) {
        if (ventas.checked) {
          this.module = false;
          this.filtros.modulo = ventas.value;
        } else if (finanzas.checked) {
          this.module = false;
          this.filtros.modulo = finanzas.value;
        } else if (vent_finan.checked) {
          this.module = false;
          this.filtros.modulo = "";
        }
      } else {
        this.module = false;
      }

      if (this.filtros.desde == "" || this.filtros.hasta == "" || this.module) {
        this.date1 = true;
        this.date2 = true;
        this.busyBusqueda = false;
        return false;
      }
      if (this.filtros.cliente == "") {
        this.clt = true;
      }

      if (this.filtros.cliente == '' && this.storageService.getCurrentUser().rol != 2) {
        this.busyBusqueda = false;
        return false;
      }

      if (this.filtros.tipoConsulta != '' && this.filtros.tipoConsulta == '1') {
        this.tipo = 'F';
      } else if (this.filtros.tipoConsulta != '' && this.filtros.tipoConsulta == '2') {
        this.tipo = 'NC';
      } else if (this.filtros.tipoConsulta != '' && this.filtros.tipoConsulta == '3') {
        this.tipo = 'C';
      } else if (this.filtros.tipoConsulta != '' && this.filtros.tipoConsulta == '4') {
        this.tipo = 'NCA';
      } else {
        this.tipo = '';
      }

      // console.log(this.filtros.tipoConsulta);
      // console.log(this.filtros.cliente);
      this.facturaRemService.obtenerFacturas(this.filtros, this.tipo).subscribe(
        data => {
          this.busyBusqueda = false;

          if (data !== null) {
            // console.log(this.filtros.desde);
            // console.log(data.zte_ext_facturas);
            this.date1 = false;
            this.date2 = false;
            this.filtros.serie1 = "";
            this.filtros.serie2 = "";
            this.filtros.folio1 = "";
            this.filtros.folio2 = "";
            this.filtros.cliente = '';
            (<HTMLInputElement>document.getElementById('fechaDesde')).value = this.filtros.desde;
            (<HTMLInputElement>document.getElementById('fechaHasta')).value = this.filtros.hasta;
            this.clt = false;
            this.rows = data.zte_ext_facturas;
          }

        },
        error => {
          if (error.status === 401) {
            this.storageService.openLogout();
          } else {
            console.log(error);
          }
          this.busyBusqueda = false;
        }
      )
    } else {
      this.tFact = true;
      this.busyBusqueda = false;
    }
    //console.log(this.filtros);
  }

  tipoConsulta() {
    if (this.filtros.tipoConsulta !== '3') {
      //Validaciones
      this.date1 = true;
      this.date2 = true;
      this.clt = true;
      this.module = true;
      this.tFact = false;
      this.show = true;
    } else {
      this.date1 = true;
      this.date2 = true;
      this.clt = true;
      this.show = false;
      this.tFact = false;
    }
  }

  notNumber(e) {
    if ( String(parseFloat(e))  == 'NaN') {
      this.filtros.cliente = '';
    }
  }

  dateChange() {
    // console.log('entro');
  }

  cancelar() {

    (<HTMLInputElement>document.getElementById('fechaDesde')).value = "";
    (<HTMLInputElement>document.getElementById('fechaHasta')).value = "";
    if (this.show) {
      (<HTMLInputElement>document.getElementById('inlineRadio1')).checked = false;
      (<HTMLInputElement>document.getElementById('inlineRadio2')).checked = false;
      (<HTMLInputElement>document.getElementById('inlineRadio3')).checked = false;
    }

    this.rows = [];
    this.show = false;
    this.filtros = {
      tipoConsulta: '',
      tipoFactura: true,
      modulo: null,
      folio1: '',
      folio2: '',
      serie1: '',
      serie2: '',
      cliente: null,
      desde: null,
      hasta: null,
      rfc: ''
    }
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    if (this.selected.length !== 0) {
      this.select = true;
    } else {
      this.select = false;
    }
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }

  fechaInicio(fechaiOpt) {
    // console.log(fechaiOpt);
  }


  descargarPdf(pdf) {
    if (pdf != '') {
      this.accountStatus.obtenerPDF(pdf, this.filtros.tipoConsulta);
    } else {
      // console.log('El registro no contiene archivo PDF.');
    }
  }


  descargarXml(xml) {
    if (xml != '') {
      this.accountStatus.obtenerXML(xml, false);
    } else {
      // console.log('El registro no contiene archivo XML.');
    }
  }

  descargaMultiple2() {
    if (this.selected.length != 0) {
      this.accountStatus.descargaMasivaArchivos(this.selected, true, true, null);
    } else {
      this.toasterService.pop('error', this.toastEmptyInvoice);
    }
  }

  enviarArchivos() {
    if (this.selected.length != 0) {
      const modal = this.modalService.open(SendFilesComponent, { size: 'lg', keyboard: false, centered: true, backdrop: 'static' });
      modal.componentInstance.passedData = this.selected;
      modal.componentInstance.tipoConsultaPassed = this.filtros.tipoConsulta;
    } else {
      this.toasterService.pop('error', this.toastEmptyInvoice);
    }
  }
  
  descargaMultiple() {
    if (this.selected.length != 0) {
      if (this.selected.length > 25 ) {
        // this.toasterService.pop('error', this.toastLimitInvoice);
          const modalRef = this.modalService.open(ResponseModal2Component, { centered: true, keyboard: false, backdrop: 'static' });
          modalRef.componentInstance.titulo = this.toastLimitInvoice;
          modalRef.componentInstance.mensaje1 = this.limitInvoiceM;
      } else {
        const modal = this.modalService.open(DownloadFilesComponent, { size: 'lg', keyboard: false, centered: true, backdrop: 'static' });
        modal.componentInstance.passedData = this.selected;
        modal.componentInstance.tipoConsultaPassed = this.filtros.tipoConsulta;
        //  this.accountStatus.descargaMasivaArchivos(this.selected);
      }

    } else {
      this.toasterService.pop('error', this.toastEmptyInvoice);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/pages/account-status/account-status.component.ts